import { useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import styled from 'styled-components';
import { Heading } from '../Heading';

import { Toggler } from '../../../Cart/components/Toggler';
import { Flex } from '../../../GlobalComponents/Flex';
import { useBreakpoint } from '../../../hooks/useBreakpoint';
import { getPrettyPickupLocation } from '../../../Order/utils/getPrettyPickupLocation';
import { useAppDispatch, useAppSelector } from '../../../reduxstore/hooks';
import { storeState } from '../../../Store/atoms';

import {
	canSkipPickupStepState,
	canSkipProfileStepState,
	pickupLocationState
} from '../../atoms';
import { OrderSummary } from '../OrderSummary';
import { setStoreSelection } from '../../../domains/UI/store/slice';

export const OrderInfo: React.FC = () => {
	const navigate = useNavigate();
	const { pathname } = useLocation();
	// const [isVisible, setIsVisible] = useState(false);
	const [isActive, setIsActive] = useState(false);
	const breakpointActive = useBreakpoint('lg');

	const pickupEmail = useAppSelector(state => state.checkoutReducer.email);

	const dispatch = useAppDispatch();

	const canSkipProfileStep = useRecoilValue(canSkipProfileStepState);
	const canSkipPickupStep = useRecoilValue(canSkipPickupStepState);
	const pickupLocation = useRecoilValue(pickupLocationState);
	const store = useRecoilValue(storeState);

	if (!store) {
		return <Navigate to="../pickup" replace />;
	}

	return (
		<OrderInfoContainer>
			{pathname === '/checkout/payment' && !breakpointActive && (
				<Wrapper>
					<Toggler
						isActive={isActive}
						onClick={() => setIsActive(!isActive)}
					></Toggler>
				</Wrapper>
			)}
			{isActive && <OrderSummary></OrderSummary>}
			<Heading $fontSize="24px">Order Info</Heading>
			<Flex $flexDirection="column" $rowGap="8px" $padding="0 0 14px 0">
				<Flex $flexDirection="column">
					<SubHeader>Contact</SubHeader>
					<Flex
						$flexDirection="row"
						$placeContent="center space-between"
					>
						<Title>{pickupEmail}</Title>
						{!canSkipProfileStep && (
							<ClickableText
								onClick={() => navigate('../profile')}
							>
								Change
							</ClickableText>
						)}
					</Flex>
				</Flex>
				<Flex $flexDirection="column" $rowGap="8px">
					<SubHeader>Location</SubHeader>
					<Flex
						$flexDirection="row"
						$placeContent="center space-between"
					>
						<Title>
							{store.nickname
								? `BIGGBY COFFEE - ${store.city}`
								: store.address1}
						</Title>
						<ClickableText
							onClick={() =>
								dispatch(
									setStoreSelection({
										isOpen: true,
										forSettingOLOStore: true,
										source: 'ORDER_INFO'
									})
								)
							}
						>
							Change
						</ClickableText>
					</Flex>
				</Flex>
				<Flex $flexDirection="column" $rowGap="8px">
					<SubHeader> Location Phone</SubHeader>
					<Flex
						$flexDirection="row"
						$placeContent="center space-between"
					>
						<Title>{store.phone}</Title>

						<ClickableText
							onClick={() => window.open(`tel:1+${store.phone}`)}
						>
							Call
						</ClickableText>
					</Flex>
				</Flex>
				<Flex $flexDirection="column" $rowGap="8px">
					<SubHeader> Picking up</SubHeader>
					<Flex
						$flexDirection="row"
						$placeContent="center space-between"
					>
						<Title>{getPrettyPickupLocation(pickupLocation)}</Title>
						{!canSkipPickupStep && (
							<ClickableText
								onClick={() => navigate('../pickup')}
							>
								Change
							</ClickableText>
						)}
					</Flex>
				</Flex>
			</Flex>
		</OrderInfoContainer>
	);
};

const OrderInfoContainer = styled.div``;

const Wrapper = styled.div`
	@media (max-width: 600px) {
		margin-top: 60px;
	}
`;

const SubHeader = styled.div`
	font-weight: 400;
	font-size: 16px;
	color: #f47920;
`;

const Title = styled.div`
	font-size: 16px;
	font-weight: 400;
	color: #575757;
`;

const ClickableText = styled.div`
	font-weight: 500;
	font-size: 16px;
	text-decoration-line: underline;
	color: #575757;
	&:hover {
		cursor: pointer;
	}
`;
